<button type="button" class="{{styleClass}}" (click)="openDaumApi()">우편번호 찾기</button>
<div id="daumAddressApiWrap" style="display:none;border:1px solid;width:500px;height:470px;margin:5px 0;position:relative">